import FeaturedRecipe, { FeaturedRecipeProps } from "./FeaturedRecipe";

export { FeaturedRecipe, FeaturedRecipeProps };

export default FeaturedRecipe;
